import { Flex, Grid, Image, Text } from '@chakra-ui/react';
import { useMemo, useState } from 'react';
import { BuyStages } from '../getGame';
import { AnimationItem } from './AnimationItem/animationItem';
import { LoadingBar } from './loadingBar';

export const DeploymentOverlay = ({ stage }: { stage: BuyStages }) => {
	const [opened, setOpened] = useState<boolean>(true);
	const visible = useMemo(() => stage > BuyStages.NOT_STARTED, [stage]);

	const handleClose = () => {
		if (stage == BuyStages.BOUGHT) {
			setOpened(false);
		}
	};

	const animationModes: any = {
		[BuyStages.NOT_STARTED]: () => (
			<AnimationItem
				header=""
				text=""
				image="/images/blockchain-transaction.gif"
			/>
		),
		[BuyStages.APPROVING]: () => <Image src="/assets/images/blockchain-transaction.gif" />,
		[BuyStages.APPROVED]: () => <Image src="/assets/images/blockchain-transaction.gif" />,
		[BuyStages.BUYING]: () => <Image src="/assets/images/blockchain-cartridge.gif" />,
		[BuyStages.BOUGHT]: () => <Image src="/assets/images/blockchain-success.gif" />,
	};
	const textModes: any = {
		[BuyStages.NOT_STARTED]: () => 'Waiting…',
		[BuyStages.APPROVING]: () => 'The store must access your USDC in order to transfer it to the creator!',
		[BuyStages.APPROVED]: () => 'Confirm the purchase to pay for the game. Every sale digs up $HASH!',
		[BuyStages.BUYING]: () => 'Processing…',
		[BuyStages.BOUGHT]: () => 'Done! Save the game in your wallet',
	};

	return (
		<Grid
			display={visible && opened ? 'flex' : 'none'}
			bg="white"
			pos="fixed"
			right="-10px"
			bottom="20px"
			padding="20px"
			paddingRight="50px"
			zIndex="10"
			color="white"
			borderRadius="8px"
			boxShadow="0px 4px 24px rgba(0, 0, 0, 0.25);"
			onClick={handleClose}
			templateColumns="1fr auto"
			gap="18px"
		>
			<Flex
				boxSize="86px"
				align="center"
				overflow="hidden"
			>
				{animationModes[stage]()}
			</Flex>
			<Flex
				flexDir="column"
				alignItems="flex-start"
				gridGap="10px"
			>
				<Text
					color="black"
					fontWeight="600"
					fontSize="18px"
				>
					Buying game...
				</Text>
				<LoadingBar stage={stage} />

				<Text
					color="black"
					maxW="300px"
					textAlign="left"
				>
					{textModes[stage]()}
				</Text>
			</Flex>
		</Grid>
	);
};
